var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"a40b3709"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

/* eslint-disable jest/require-hook */

import * as Sentry from '@sentry/nextjs'

import { defaultSentryOptions } from './src/constants/sentryConfig'

Sentry.init({
  ...defaultSentryOptions,
  enableTracing: false,
})
